module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 16
// module chunks = 0